var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GreyBarWithTitleAndValue',{attrs:{"is-with-borders":"","title":"Departures per Month","value":_vm.$numberManagement.numberWithComma(_vm.itemData)}})
}
var staticRenderFns = []

export { render, staticRenderFns }